<div class="gap-xs">
  <div class="col display-not-mobile mrxs float-left">
    <div class="cell phs invisible">&nbsp;</div>
    @for (row of rows; track row) {
      <div class="cell attribute phs">
        <pr-label [tooltip]="row.labelTooltip" labelClass="fw-500 fs-16">{{
          row.label
        }}</pr-label>
      </div>
    }
  </div>
  <pr-swiper
    swiperMinWidth="992"
    class="flex-stretch"
    [defaultClass]="'grid grid-col-md-1 ' + ' grid-col-' + subjects.length"
  >
    @for (subject of subjects; track subject) {
      <pr-slide>
        <div class="col" style="position: relative">
          <ng-container
            [ngTemplateOutlet]="overhead"
            [ngTemplateOutletContext]="{ $implicit: subject }"
          ></ng-container>
          <!-- column -->
          <div
            class="cell column"
            [ngStyle]="{ 'background-color': subject.color }"
          >
            {{ subject.label }}
          </div>
          <!-- cells -->
          @for (
            cell of subject.cells;
            track cell;
            let i = $index;
            let isFirst = $first;
            let isLast = $last
          ) {
            <div
              class="cell"
              [ngStyle]="{
                'padding-top': mdq && isFirst ? '10px' : '0',
                'padding-bottom': mdq && isLast ? '10px' : '0',
              }"
              [ngClass]="{
                check: cell.checked,
                cross: cell.cross,
                'recommended-solution-cells': cell.optimize,
              }"
            >
              <span class="cell-attribute fs-13 fw-400">{{
                rows[i].label
              }}</span>
              @if (cell.checked) {
                <pr-icon
                  name="sp-check-opti"
                  [viewBoxWidth]="16"
                  [viewBoxHeight]="16"
                  [width]="16"
                  [height]="16"
                ></pr-icon>
              }
              @if (cell.cross) {
                <pr-icon
                  name="fa-close"
                  [viewBoxWidth]="16"
                  [viewBoxHeight]="16"
                  [width]="16"
                  [height]="16"
                >
                </pr-icon>
              }
              @if (cell.value !== null && cell.value !== undefined) {
                <pr-value
                  type="{{ cell.type }}"
                  value="{{ cell.value }}"
                  prefix="{{ cell.prefix }}"
                  suffix="{{ cell.suffix }}"
                >
                </pr-value>
              }
              @if (cell.value === null || cell.value === undefined) {
                <span>-</span>
              }
            </div>
          }
        </div>
      </pr-slide>
    }
  </pr-swiper>
</div>

<ng-template #overhead let-data>
  @if (data.optimized || data.overhead) {
    <div
      class="recommended-solution"
      [ngStyle]="{ 'background-color': data.overheadColor }"
    >
      {{ data.overhead || 'Solution recommandée' }}
    </div>
  }
</ng-template>
